import { isTaskScoped, ScanGroupOptimized, ScanTaskOptimized } from '@kaiizen/kai-scan-template-system';

import { groupNamePresenter } from '@kaiizen/kai-presenters';
import { ScanNavigatorGroupItem, ScanNavigatorLayout, ScanNavigatorSectionHeader } from '../ScanNavigator';
import { ProgressScanNavigatorTaskItem } from './ProgressScanNavigatorTaskItem';

export const ProgressScanNavigator = ({
  scopedGroups,
  scanId,
  currentGroup,
  currentTask,
}: {
  scopedGroups: ScanGroupOptimized[];
  scanId: string;
  currentGroup?: ScanGroupOptimized;
  currentTask?: ScanTaskOptimized;
}) => {
  return (
    <ScanNavigatorLayout>
      <ScanNavigatorSectionHeader title='Groups' buttons />
      {scopedGroups.map(group => (
        <ScanNavigatorGroupItem
          key={group.id}
          group={group}
          progress
          isCurrentGroup={group.id === currentGroup?.id}
        />
      ))}
      {currentGroup && <ScanNavigatorSectionHeader title={groupNamePresenter(currentGroup) + ' Tasks'} buttons />}
      {currentGroup?.tasks?.map(task => (
        isTaskScoped(task) && (
          <ProgressScanNavigatorTaskItem
            key={task.id}
            groupId={currentGroup?.id}
            task={task}
            scanId={scanId}
            isCurrentTask={task.id === currentTask?.id}
          />
        )
      ))}
    </ScanNavigatorLayout>
  );
};
